(function () {
  'use strict';

  var PANEL_SELECTOR = '.bnk-purchase-panel';
  var OFFER_SELECTOR = '.omg-groupsTable, .otTableOffer, .omg-offer, [id^="omg-offer"]';
  var observer = null;
  var scheduled = false;
  var rendering = false;

  function text(element) {
    return element ? element.textContent.replace(/\s+/g, ' ').trim() : '';
  }

  function mainQuantity(productInfo) {
    var blocks = productInfo.querySelectorAll('.product-form__quantity');
    for (var i = 0; i < blocks.length; i += 1) {
      if (blocks[i].querySelector('input.quantity__input[name="quantity"]')) return blocks[i];
    }
    return null;
  }

  function mainProductForm(productInfo) {
    var forms = productInfo.querySelectorAll('product-form.product-form');
    for (var i = 0; i < forms.length; i += 1) {
      if (forms[i].querySelector('.product-form__submit')) return forms[i];
    }
    return null;
  }

  function cartIcon() {
    var svg = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
    svg.classList.add('bnk-purchase-panel__cart-icon');
    svg.setAttribute('aria-hidden', 'true');
    svg.setAttribute('viewBox', '0 0 24 24');
    svg.setAttribute('width', '20');
    svg.setAttribute('height', '20');
    svg.setAttribute('fill', 'none');
    svg.innerHTML = '<path d="M3 4h2l1.6 9.2a2 2 0 0 0 2 1.7h7.9a2 2 0 0 0 1.9-1.4L20 8H6" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/><circle cx="9" cy="19" r="1.4" fill="currentColor"/><circle cx="17" cy="19" r="1.4" fill="currentColor"/>';
    return svg;
  }

  function ensureCartIcon(root) {
    var submit = root && root.querySelector('.product-form__submit');
    if (submit && !submit.querySelector('.bnk-purchase-panel__cart-icon')) {
      submit.insertBefore(cartIcon(), submit.firstChild);
    }
  }

  function createPanel(productInfo, quantityBlock, productForm) {
    var panel = document.createElement('section');
    panel.className = 'bnk-purchase-panel';
    panel.setAttribute('data-bnk-purchase-panel', '');
    panel.setAttribute('aria-label', 'Purchase');

    var actions = document.createElement('div');
    actions.className = 'bnk-purchase-panel__actions';

    quantityBlock.classList.add('bnk-purchase-panel__quantity');
    productForm.classList.add('bnk-purchase-panel__form');

    ensureCartIcon(productForm);

    quantityBlock.parentNode.insertBefore(panel, quantityBlock);
    panel.appendChild(actions);
    actions.appendChild(quantityBlock);
    actions.appendChild(productForm);

    return panel;
  }

  function mountPlateDistribution(productInfo, productForm, panel) {
    var distribution = productInfo.querySelector('[data-bnk-platedist]');
    if (!distribution || !panel || !panel.parentNode) return;
    if (distribution.parentNode !== panel.parentNode || distribution.nextElementSibling !== panel) {
      panel.parentNode.insertBefore(distribution, panel);
    }
  }

  // BIONIKA (2026-08-12): a „Több méret egyszerre" nyitógomb a panelbe, KÖZVETLENÜL a
  // kosárgomb alá kerül. A Liquidben a buy-buttons blokk után áll, de a panel a
  // <product-form>-ot kiemeli onnan, így a gomb a helyén maradt — a kedvezmény-csempék
  // ALATT, a kosárgombtól elszakadva. (A csempéket a renderTiers a panel VÉGÉRE teszi,
  // ezért a gomb a kosárgomb és a csempék közé kerül.)
  function mountSizeButton(productInfo, panel) {
    var button = productInfo.querySelector('.bnk-sm-open');
    if (!button || !panel) return;
    var actions = panel.querySelector('.bnk-purchase-panel__actions');
    if (!actions) return;
    if (button.parentNode === panel && button.previousElementSibling === actions) return;
    actions.insertAdjacentElement('afterend', button);
  }

  function findOffer(productInfo) {
    var local = productInfo.querySelector(OFFER_SELECTOR);
    if (local) return local;
    var all = document.querySelectorAll(OFFER_SELECTOR);
    return all.length === 1 ? all[0] : null;
  }

  function offerRoot(offer) {
    return offer.closest('.omg-groupsTable') || offer.closest('.otTableOffer') || offer.closest('.omg-offer') || offer;
  }

  function extractTiers(offer) {
    var table = offer.matches('table') ? offer : offer.querySelector('table');
    if (!table) return [];
    var rows = table.querySelectorAll('tr');
    var tiers = [];

    for (var i = 0; i < rows.length; i += 1) {
      var cells = rows[i].querySelectorAll('td');
      if (cells.length < 3) continue;
      var quantityText = text(cells[0]);
      var quantityMatch = quantityText.match(/\d+/);
      if (!quantityMatch) continue;
      tiers.push({
        quantity: parseInt(quantityMatch[0], 10),
        discount: text(cells[1]),
        price: text(cells[2])
      });
    }

    tiers.sort(function (a, b) { return a.quantity - b.quantity; });
    return tiers;
  }

  function normalizedQuantity(input, wanted) {
    var min = parseInt(input.getAttribute('min') || input.dataset.min || '1', 10);
    var max = parseInt(input.getAttribute('max') || input.dataset.max || '0', 10);
    var step = parseInt(input.getAttribute('step') || '1', 10);
    var value = Math.max(isNaN(min) ? 1 : min, wanted);
    if (!isNaN(max) && max > 0) value = Math.min(max, value);
    if (!isNaN(step) && step > 1) {
      var base = isNaN(min) ? 0 : min;
      value = base + Math.ceil((value - base) / step) * step;
    }
    return value;
  }

  function setQuantity(input, quantity) {
    var value = normalizedQuantity(input, quantity);
    input.value = String(value);
    input.dispatchEvent(new Event('input', { bubbles: true }));
    input.dispatchEvent(new Event('change', { bubbles: true }));
  }

  function updateState(panel) {
    var input = panel.querySelector('input.quantity__input[name="quantity"]');
    var cards = panel.querySelectorAll('.bnk-volume-tier');
    var status = panel.querySelector('.bnk-volume-offers__status');
    if (!input || !cards.length || !status) return;

    var quantity = parseInt(input.value || '1', 10);
    if (isNaN(quantity)) quantity = 1;
    var active = null;
    var next = null;

    for (var i = 0; i < cards.length; i += 1) {
      var threshold = parseInt(cards[i].dataset.quantity, 10);
      if (quantity >= threshold) active = cards[i];
      if (!next && quantity < threshold) next = cards[i];
    }

    for (var j = 0; j < cards.length; j += 1) {
      var isActive = cards[j] === active;
      cards[j].classList.toggle('is-active', isActive);
      cards[j].classList.toggle('is-next', cards[j] === next);
      if (cards[j].getAttribute('aria-pressed') !== String(isActive)) {
        cards[j].setAttribute('aria-pressed', String(isActive));
      }
    }

    var statusText;
    if (next) {
      var remaining = parseInt(next.dataset.quantity, 10) - quantity;
      statusText = 'Add ' + remaining + ' more pcs to get a ' + next.dataset.discount + ' discount.';
    } else if (active) {
      statusText = 'The highest discount tier (' + active.dataset.discount + ') is active.';
    } else {
      statusText = 'Please choose a discounted quantity from the options below.';
    }
    if (status.textContent !== statusText) status.textContent = statusText;
  }

  function renderTiers(panel, offer, tiers) {
    var existing = panel.querySelector('.bnk-volume-offers');
    if (existing) existing.remove();
    if (!tiers.length) return;

    var section = document.createElement('div');
    section.className = 'bnk-volume-offers';
    section.innerHTML = '<div class="bnk-volume-offers__head"><h3 class="bnk-volume-offers__title">Volume discounts</h3><span class="bnk-volume-offers__hint">Click a tier to set the quantity</span></div>';

    var grid = document.createElement('div');
    grid.className = 'bnk-volume-offers__grid';

    tiers.forEach(function (tier) {
      var card = document.createElement('button');
      card.type = 'button';
      card.className = 'bnk-volume-tier';
      card.dataset.quantity = String(tier.quantity);
      card.dataset.discount = tier.discount;
      card.setAttribute('aria-pressed', 'false');
      card.setAttribute('aria-label', 'From ' + tier.quantity + ' pcs: ' + tier.discount + ' discount, ' + tier.price + ' each');
      card.innerHTML = '<span class="bnk-volume-tier__minimum">' + tier.quantity + '+ pcs</span>' +
        '<span class="bnk-volume-tier__discount">−' + tier.discount + '</span>' +
        '<span class="bnk-volume-tier__price">' + tier.price + '<span class="bnk-volume-tier__unit">/ pc</span></span>';
      card.addEventListener('click', function () {
        var input = panel.querySelector('input.quantity__input[name="quantity"]');
        if (!input) return;
        setQuantity(input, tier.quantity);
        updateState(panel);
      });
      grid.appendChild(card);
    });

    var status = document.createElement('p');
    status.className = 'bnk-volume-offers__status';
    status.setAttribute('aria-live', 'polite');

    section.appendChild(grid);
    section.appendChild(status);
    panel.appendChild(section);

    var input = panel.querySelector('input.quantity__input[name="quantity"]');
    if (input && !input.dataset.bnkVolumeBound) {
      input.dataset.bnkVolumeBound = 'true';
      input.addEventListener('input', function () { updateState(panel); });
      input.addEventListener('change', function () { updateState(panel); });
    }

    if (offer) {
      offerRoot(offer).classList.add('bnk-volume-source');
      offerRoot(offer).setAttribute('aria-hidden', 'true');
    }
    updateState(panel);
  }

  // Tartalék: a quick-add modálban a kedvezmény-app (Pareto/OMG) nem hidratálja a
  // tábláját (üres konténereket hagy), így nincs mit kiolvasni. Ilyenkor a szinteket
  // a globális window.omgQuantityData szabályaiból és a megjelenített árból számoljuk.
  function tiersFromAppData(productInfo) {
    try {
      var forras = window.BNK_VOLUME_DATA || window.omgQuantityData;   // saját metaobjektum, majd a régi app
      var offers = (forras && forras.offers) || [];
      var offer = null;
      for (var i = 0; i < offers.length; i += 1) {
        if (String(offers[i].status) === '1' && String(offers[i].all_product_rule) === '1') { offer = offers[i]; break; }
      }
      if (!offer || !offer.discount_rule || !offer.discount_rule.length) return [];
      var saleEl = productInfo.querySelector('.price__sale .price-item--sale');
      var regEl = productInfo.querySelector('.price__regular .price-item--regular, .price-item--regular');
      var priceEl = (saleEl && saleEl.offsetParent) ? saleEl : regEl;
      var digits = text(priceEl).replace(/[^\d]/g, '');
      if (!digits) return [];
      // EUR: the displayed price always carries two decimals (de-DE format),
      // so the stripped digits are cents — convert back to euros.
      var unit = parseInt(digits, 10) / 100;
      var tiers = [];
      offer.discount_rule.forEach(function (r) {
        if (r.discount_unit !== 'percent' || r.discount_type !== 'per_item') return;
        var q = parseInt(r.buy_from, 10);
        var pct = parseFloat(r.discount_value);
        if (isNaN(q) || isNaN(pct)) return;
        var p = unit * (1 - pct / 100);
        tiers.push({ quantity: q, discount: Math.round(pct) + '%', price: p.toLocaleString('de-DE', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + ' €' });
      });
      tiers.sort(function (a, b) { return a.quantity - b.quantity; });
      return tiers;
    } catch (e) { return []; }
  }

  function mountProductInfo(productInfo) {
    var quantityBlock = mainQuantity(productInfo);
    var productForm = mainProductForm(productInfo);
    if (!quantityBlock || !productForm) return;

    var panel = productInfo.querySelector(PANEL_SELECTOR);
    if (!panel) panel = createPanel(productInfo, quantityBlock, productForm);
    mountPlateDistribution(productInfo, productForm, panel);
    mountSizeButton(productInfo, panel);
    ensureCartIcon(panel);

    var offer = findOffer(productInfo);
    var tiers = offer ? extractTiers(offer) : [];
    if (!tiers.length) tiers = tiersFromAppData(productInfo);
    if (!tiers.length) return;
    var signature = tiers.map(function (tier) {
      return [tier.quantity, tier.discount, tier.price].join('|');
    }).join('||');
    if (!signature || panel.dataset.bnkTierSignature === signature) {
      updateState(panel);
      return;
    }
    panel.dataset.bnkTierSignature = signature;
    renderTiers(panel, offer, tiers);
  }

  function mountAll() {
    if (rendering) return;
    rendering = true;
    try {
      var productInfos = document.querySelectorAll('[id^="ProductInfo-"]');
      for (var i = 0; i < productInfos.length; i += 1) mountProductInfo(productInfos[i]);
    } finally {
      rendering = false;
    }
  }

  function clearLoadingState() {
    document.documentElement.classList.remove('bnk-purchase-loading');
  }

  function scheduleMount() {
    if (scheduled) return;
    scheduled = true;
    window.requestAnimationFrame(function () {
      scheduled = false;
      try {
        mountAll();
      } finally {
        clearLoadingState();
      }
    });
  }

  function addedNodeNeedsMount(node) {
    if (!node || node.nodeType !== 1) return false;
    if (node.closest(PANEL_SELECTOR)) return false;

    var triggerSelector = '[id^="ProductInfo-"], product-form.product-form, .product-form__quantity, .product-form__submit, ' + OFFER_SELECTOR;
    return node.matches(triggerSelector) || !!node.querySelector(triggerSelector) || !!node.closest(OFFER_SELECTOR);
  }

  function start() {
    try {
      mountAll();
    } finally {
      clearLoadingState();
    }
    if (!window.MutationObserver || !document.body) return;
    observer = new MutationObserver(function (mutations) {
      if (rendering) return;
      for (var i = 0; i < mutations.length; i += 1) {
        var target = mutations[i].target;
        if (target.nodeType === 1 && target.closest(PANEL_SELECTOR)) continue;

        if (target.nodeType === 1 && target.closest(OFFER_SELECTOR)) {
          scheduleMount();
          return;
        }

        for (var j = 0; j < mutations[i].addedNodes.length; j += 1) {
          var node = mutations[i].addedNodes[j];
          if (!addedNodeNeedsMount(node)) continue;
          if (node.matches('[id^="ProductInfo-"]') || node.querySelector('[id^="ProductInfo-"]')) {
            document.documentElement.classList.add('bnk-purchase-loading');
          }
          scheduleMount();
          return;
        }
      }
    });
    observer.observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, { once: true });
  } else {
    start();
  }

  document.addEventListener('shopify:section:load', scheduleMount);
})();
